// extracted by mini-css-extract-plugin
export default {"skipToContent":"U8xt0o5tDDA3zaTD3vZa"};